import { combineReducers, configureStore } from '@reduxjs/toolkit';
// import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
// import { history } from '../history';
import user from './user';
import reducer from './reducer';
import registration from './registration';
import policy from './policy';
import phoneCodeOpenApi from './openApi';
import consentWorkFlow from './consentWorkFlow';
import onboardingExitReviewsFlow from './onboardAndExitReview';
import COEonboardingReviewsFlow from './COEonboardAReview';
import onboardingReviewsEditableFlow from './onboardReviewEditable';
import forceSignOutSliceFlow from './forceLogOut';
import HRMSUser from './hrms';
import KYCDigioSignFlow from './KYCDigioSign';

export type RootState = ReturnType<typeof rootReducer>;

const rootReducer = combineReducers({
    // router: connectRouter(history),
    registration,
    policy,
    phoneCodeOpenApi,
    user,
    HRMSUser,
    toolkit: reducer,
    consentWorkFlow,
    onboardingExitReviewsFlow,
    onboardingReviewsEditableFlow,
    COEonboardingReviewsFlow,
    forceSignOutSliceFlow,
    KYCDigioSignFlow,
});

export const store = configureStore({
    reducer: rootReducer,
});

export const history = createBrowserHistory();

export type AppDispatch = typeof store.dispatch;
